
export default function Products() {
  return (
    <section id="products" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-8 lg:px-16">
        <h2 className="text-5xl font-bold text-gray-900 text-center mb-16">
          Our Products
        </h2>
        
        <div className="grid md:grid-cols-2 gap-10">
          <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-blue-900 via-purple-800 to-purple-700 p-12 min-h-[500px] flex flex-col justify-between">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10">
              <div className="w-28 h-28 bg-white/20 rounded-2xl flex items-center justify-center mb-6 backdrop-blur-sm">
                <i className="ri-shield-check-line text-5xl text-white"></i>
              </div>
              
              <h3 className="text-4xl font-bold text-white mb-8">VPN</h3>
              
              <ul className="space-y-4 text-white text-lg">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Military-grade encryption</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Global server network</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Zero-log policy</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Lightning-fast connection</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-orange-500 via-pink-500 to-pink-600 p-12 min-h-[500px] flex flex-col justify-between">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10">
              <div className="w-28 h-28 bg-white/20 rounded-2xl flex items-center justify-center mb-6 backdrop-blur-sm">
                <i className="ri-brush-line text-5xl text-white"></i>
              </div>
              
              <h3 className="text-4xl font-bold text-white mb-8">Cleaner</h3>
              
              <ul className="space-y-4 text-white text-lg">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Smart storage optimization</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Duplicate file detection</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Photo compression</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-1"></i>
                  <span>Battery performance boost</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
